var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgFunctionalError = function SvgFunctionalError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#functionalError_svg__clip0_8950_83715)",
    fill: "#AB5820"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.667 5.334H7.333v5.333h1.334V5.334zM8.667 12H7.333v1.334h1.334V12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.763 12.916L9.783 1.168A1.978 1.978 0 008 .075c-.706 0-1.411.365-1.782 1.093L.237 12.916C-.482 14.328.543 16 2.127 16h11.746c1.584 0 2.609-1.672 1.89-3.084zm-1.218 1.374a.776.776 0 01-.672.377H2.127a.776.776 0 01-.672-.377.777.777 0 01-.03-.769L7.406 1.773A.65.65 0 018 1.409a.65.65 0 01.594.364l5.981 11.748a.776.776 0 01-.03.77z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "functionalError_svg__clip0_8950_83715"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgFunctionalError;